export default "<ion-router-outlet main></ion-router-outlet>\r\n    \r\n\r\n"